'use client';

// src/hooks/useNouvellePresentation.ts
// L'interrupteur de la nouvelle présentation (pages en trois colonnes, 16/10/2026).
//
// POURQUOI. David (16/10/2026) : la nouvelle présentation est « du très beau boulot », mais
// elle doit rester visible de nous seuls tant que l'essentiel du site n'est pas converti, pour
// que le site servi aux testeurs ne soit pas « en grand écart entre deux styles ». Seuil
// d'ouverture fixé par David : analyses, acteurs (baromètres et investigations compris) et
// organisations convertis, au minimum.
//
// Un seul serveur, une seule branche : la nouvelle présentation s'affiche pour un compte admin
// (le rang enregistré, pas un rang simulé) ; tout le monde garde l'ancienne. Le jour de
// l'ouverture, `NEXT_PUBLIC_NOUVELLE_PRESENTATION=tous` la donne à tous sans toucher au code.

import { useSession } from 'next-auth/react';
import { useBreakpoint } from '@/hooks/useBreakpoint';

export function useNouvellePresentation(): boolean {
  const { data: session } = useSession();
  if (process.env.NEXT_PUBLIC_NOUVELLE_PRESENTATION === 'tous') return true;
  return session?.user?.tier === 'admin';
}

// La largeur à partir de laquelle les pages passent en trois colonnes (20/10/2026). David :
// « la vue tablette devait aussi profiter du mode 3 colonnes, juste les mobiles exclus ». Les
// pages s'arrêtaient à 1024 px ; une tablette en portrait (768-1023 px) a désormais la grille
// sur deux colonnes, le contexte sous le centre (geov2.css). En dessous, l'ancienne vue.
export const LARGEUR_TROIS_COLONNES = 768;

/** La nouvelle présentation, et assez de largeur pour elle. Le seul test des pages converties. */
export function useTroisColonnes(): boolean {
  const nouvelle = useNouvellePresentation();
  const { w } = useBreakpoint();
  return nouvelle && w >= LARGEUR_TROIS_COLONNES;
}
